import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Subscription, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class NotificationService {
 
  private baseUrl = `${environment.apiUrl}/script.php`;
  private unreadCountSource = new BehaviorSubject<number>(0);
  
  // 2. This is what components "listen" to
  unreadCount$ = this.unreadCountSource.asObservable();

  

  constructor(private http: HttpClient) {}

  getNotificationCount(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}?reqtype=getNotificationCount`, data);
  }

  getNotifications(data: any): Observable<{ data: any[];}> {
    return this.http.post<{ data: any[]; }>(`${this.baseUrl}?reqtype=getNotifications`, data);
  }

  markReadStatus(data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}?reqtype=marknotificationread`, data);
  }

  // Handy way to get the current value without subscribing
  getCurrentCount(): number {
    return this.unreadCountSource.value;
  }
  
  // 3. The method to change the number
  updateCount(count: number) {
    this.unreadCountSource.next(count);
  }
}

